<template>
    <div :class="['chat-user-item', { 'chat-user-item--active': active }]">
        <!-- Avatar -->
        <div class="chat__avatar">
            <el-badge is-dot :hidden="Boolean(info.thread.lastMsg.read)">
                <el-avatar :size="38" :src="avatar"></el-avatar>
            </el-badge>
        </div>

        <div class="chat__msg">
            <!-- User -->
            <div class="chat__msg-info">
                <div class="user-name nr normal line-1">{{ info?.group?.name }}</div>
                <div class="msg-time xs muted m-l-5">{{ getTime }}</div>
            </div>

            <!-- Message -->
            <div class="chat__msg-content xs">
                <div class="msg-content muted line-1 flex-1" v-html="getMessage"></div>
            </div>
        </div>
    </div>
</template>


<script>
import { timeFormatChat } from '@/utils/date'
export default {
    name: 'ChatGroupItem',
    props: {
       info:{
            type:Object,
            default:{}
       },
       active: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        getTime() {
            return this.info.thread.update_time ? timeFormatChat(new Date(this.info.thread.update_time).getTime()) : ''
        },
        getMessage() {
            switch (Number(this.info.thread.lastMsg.content.type)) {
                case 1: return this.info.thread.lastMsg.content.payload.txt.replace(/\[em-([a-z_]+)\]/g, `<span class="em em-$1"></span>`)
                case 2: return '图片消息'
                case 3: return '商品消息'
                case 8: return '卡片消息'
                case 9: return '优惠券消息'
            }
        },
        imageURL() {
            return this.$store.getters.baseUrl
        },
        avatar(){
            return this.imageURL + this.info.order.status+'.png';
            
        }
    },
    mounted(){

    }
}
</script>


<style lang="scss" scoped>
.chat-user-item {
    display: flex;
    align-items: center;
    padding: 0 10px;
    height: 70px;
    cursor: pointer;

    &--active {
        background-color: #f5f5f5;
    }
    
    .chat__avatar {
        display: flex;
        position: relative;
        align-items: center;
        height: 38px;
        margin-right: 10px;
        //opacity: 0.5;
        // &--online {
        //     //opacity: 1;
        // }
        ::v-deep .el-badge__content.is-dot {
            height: 10px;
            width: 10px;
            box-sizing: content-box;
        }
        .chat__oline_circle {
            position: absolute;
            right:0;
            bottom:0;
            width:10px;
            height: 10px;
            border-radius: 50px;
            background-color: #e3e3e3;
            &--online {
                background-color: #00ff00;
            }
        }
    }
    

    .chat__msg {
        flex: 1;
        display: flex;
        flex-direction: column;
        height: 38px;
        overflow: hidden;

        &-info {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .user-name {
                flex: 1;
                white-space: nowrap;
                text-overflow: ellipsis;
            }

            .msg-time {
            }
        }

        &-content {
            flex: 1;
            display: flex;
            align-items: center;

            .msg-badge {
                margin-left: auto;
                line-height: 0;
            }
        }
    }
}
</style>